import { createSlice } from "@reduxjs/toolkit";
import { getCustomerList, getCustomerCount, getCustomersPag } from "./thunks";
import { logOut } from "../authentication/authenticationSlice";

// const initialState = {
//   list: {
//     pageIndex: 0,
//     totalRecords: 50,
//     totalPages: 1,
//     hasPreviousPage: false,
//     hasNextPage: false,
//     elements: [],
//   },
//   loading: "idle",
//   loadingCount: "idle",
//   error: null,
// };

const initialState = {
  list: [],
  listPag: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: [],
  },
  loading: "idle",
  loadingPag: "idle",
  loadingCount: "idle",
  error: null,
};


// const initialState = {
//   entryChannels: [],
//   listPag: {
//     pageIndex: 0,
//     totalRecords: 10,
//     totalPages: 1,
//     pageSize: 10,
//     hasPreviousPage: false,
//     hasNextPage: false,
//     elements: [],
//   },
//   loading: "idle",
//   loadingPag: "idle",
//   error: null,
// };





const customerSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    clearCustomerError: (state) => {
      state.error = null;
    },
    setCustomerFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
  extraReducers: {
    [getCustomerList.pending]: (state) => {
      state.loading = "loading";
      state.error = null;
    },
    [getCustomerList.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.list = action.payload;
    },
    [getCustomerList.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [getCustomersPag.pending]: (state) => {
      state.loadingPag = "loading";
      state.error = null;
    },
    [getCustomersPag.fulfilled]: (state, action) => {
      state.loadingPag = "succeeded";
      state.listPag.elements = action.payload.elements;
      state.listPag.pageIndex = action.payload.pageIndex;
      state.listPag.pageSize = action.payload.pageSize;
      state.listPag.totalRecords = action.payload.totalRecords;
      state.listPag.totalPages = action.payload.totalPages;
      state.listPag.hasPreviousPage = action.payload.hasPreviousPage;
      state.listPag.hasNextPage = action.payload.hasNextPage;
    },
    [getCustomersPag.rejected]: (state, action) => {
      state.loadingPag = "failed";
      state.error = action.error.message;
    },
    [getCustomerCount.pending]: (state) => {
      state.loadingCount = "loading";
      state.error = null;
    },
    [getCustomerCount.fulfilled]: (state, action) => {
      state.loadingCount = "succeeded";
      state.list.pageIndex = action.payload.pageIndex;
      state.list.totalRecords = action.payload.totalRecords;
      state.list.totalPages = action.payload.totalPages;
      state.list.hasPreviousPage = action.payload.hasPreviousPage;
      state.list.hasNextPage = action.payload.hasNextPage;
    },
    [getCustomerCount.rejected]: (state, action) => {
      state.loadingCount = "failed";
      state.error = action.error.message;
    },
  },
  [logOut]: (state) => initialState,
});

export const { clearCustomerError, setCustomerFilters } = customerSlice.actions;

export default customerSlice.reducer;
